<template>
    <!--
        NOTE: 'scroll-strategy="none"' is a workaround for the following issue:
               https://github.com/vuetifyjs/vuetify/issues/16770
               May cause side-effects...
     -->
    <v-dialog
        v-model="dialog"
        :fullscreen="isFullScreen"
        :hide-overlay="isFullScreen"
        :width="modalWidth"
        :transition="isFullScreen ? 'dialog-bottom-transition' : 'dialog-transition'"
        :persistent="persistent"
        scroll-strategy="block"
        @update:modelValue="$event === false ? onExit() : void(0)"
    >
        <template #default="{ isActive }">
            <slot
                :openCount="openCount"
                :onExit="onExit"
                :isActive="isActive"
            ></slot>
        </template>
    </v-dialog>
</template>

<script lang="ts" setup>
    import { useDisplay } from 'vuetify';

    const props = withDefaults(
        defineProps<{
            modelValue: Nilish<boolean>;
            width?: string;
            mobileWidth?: string;
            persistent?: boolean;
        }>(),
        {
            modelValue: false,
            width: '40%',
            mobileWidth: '60%',
            persistent: true
        }
    );

    const emit = defineEmits<{
        'update:modelValue': [value: boolean];
        'on-exit': [value: void];
    }>();

    const useDisplayObj = useDisplay();
    const dialog = ref<boolean>(props.modelValue ?? false);
    const openCount = ref<number>(0);

    const modalWidth = computed<string>(() => {
        if (useDisplayObj.md.value) {
            return props.mobileWidth;
        } else if (useDisplayObj.mobile.value) {
            return '100%';
        } else {
            return props.width;
        }
    });

    const isFullScreen = computed<boolean>(() => {
        return modalWidth.value === '100%';
    });

    const unWatch = watch(
        () => props.modelValue,
        (val) => {
            if (val) {
                openCount.value++;
            }

            dialog.value = val ?? false;
        }
    );

    function onExit(): void {
        emit('update:modelValue', false);
        emit('on-exit');
    }

    onBeforeUnmount(() => {
        unWatch();
    });
</script>

<style lang="scss"></style>
